// extracted by mini-css-extract-plugin
export default {"container":"FallbackAvatar_container__eaJyV"};